export enum ProjectMemberPermissions {
  none = "none",
  viewer = "viewer",
  contributor = "contributor",
  admin = "admin",
}

export const projectMemberPermissionsLabels = {
  [ProjectMemberPermissions.viewer]: "Viewer",
  [ProjectMemberPermissions.contributor]: "Contributor",
  [ProjectMemberPermissions.admin]: "Admin",
};

export const projectMemberPermissions = Object.keys(
  projectMemberPermissionsLabels,
).map<{
  label: string;
  value: ProjectMemberPermissions;
}>((key) => ({
  label: projectMemberPermissionsLabels[key],
  value: ProjectMemberPermissions[key],
}));
